import { format } from "date-fns";

Date.prototype.addDays = function (days) {
  var dat = new Date(this.valueOf());
  dat.setDate(dat.getDate() + days);
  return dat;
};

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const HAS_TIMEZONE_REGEX = /([zZ]|[+-]\d{2}:\d{2})$/;

const parseDatePreservingDay = (date) => {
  if (!date) return null;

  // Date object already represents an instant; just use it
  if (date instanceof Date) return date;

  if (typeof date === "string") {
    // Treat YYYY-MM-DD as a "date-only" in local time to avoid timezone shifts
    if (DATE_ONLY_REGEX.test(date)) {
      const [year, month, day] = date.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    return new Date(date);
  }

  return new Date(date);
};

const convertToDateOnly = (date) => {
  const dt = parseDatePreservingDay(date);
  if (!dt || Number.isNaN(dt.getTime())) return "";

  return format(dt, "dd/MM/yyyy");
};

const convertToDateTime = (date) => {
  const dt = parseDatePreservingDay(date);
  if (!dt || Number.isNaN(dt.getTime())) return "";

  return format(dt, "dd/MM/yyyy HH:mm");
};

const convertToYearOnly = (date) => {
  const dt = parseDatePreservingDay(date);
  if (!dt || Number.isNaN(dt.getTime())) return "";

  return format(dt, "yyyy");
};

const listDatesBetween = (startDate, stopDate, compareToday) => {
  var dateArray = [];

  if (compareToday) {
    const today = new Date();
    if (startDate.valueOf() < today.valueOf()) startDate = today;
  }

  // Keep dates in local time; avoid manual timezone offset shifting
  var currentDate = new Date(startDate.valueOf());
  var finalDate = new Date(stopDate.valueOf());

  while (currentDate <= finalDate) {
    dateArray.push({
      label: format(new Date(currentDate), "dd/MM/yyyy"),
      value: new Date(currentDate),
    });
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
};

const listDatesBetweenNewUX = (startDate, stopDate, compareToday) => {
  var dateArray = [];

  if (compareToday) {
    const today = new Date();
    if (startDate.valueOf() < today.valueOf()) startDate = today;
  }

  // Keep dates in local time; avoid manual timezone offset shifting
  var currentDate = new Date(startDate.valueOf());
  var finalDate = new Date(stopDate.valueOf());

  while (currentDate <= finalDate) {
    dateArray.push({
      label: format(new Date(currentDate), "dd/MM/yyyy"),
      value: format(new Date(currentDate), "yyyy-MM-dd"),
    });
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
};

const inputTimeInsideDate = ({ date, time }) => {
  let dateAux = date;
  let timeAux = time.split(":");

  dateAux.setUTCHours(timeAux[0], timeAux[1], 0, 0);

  return dateAux;
};

const inputTimeInsideDateNewUX = ({ date, time }) => {
  return date + "T" + time + ":00.000Z";
};

const convertYYYYMMDDToDate = (dateString) => {
  if (!dateString) return "";

  const parts = dateString.split("-");
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
  const day = parseInt(parts[2], 10);

  return new Date(year, month, day);
};

export {
  convertToDateOnly,
  convertToDateTime,
  convertToYearOnly,
  listDatesBetween,
  inputTimeInsideDate,
  listDatesBetweenNewUX,
  inputTimeInsideDateNewUX,
  convertYYYYMMDDToDate,
};
